import API from '../api'
import putUrl from './paths'

export const editContent = (content) =>
    new Promise((resolve, reject) => {
        API.put(putUrl.editContent, { ...content })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })